
import { useReducer, useRef, useState, useContext, useEffect } from "react";
import { useAccordionButton, AccordionContext, Card, Badge, Button, Fade, Col, Accordion } from 'react-bootstrap';
import AccordionHeader from "../AccordionHeader";
import Item2 from "../Item2";
import { ACTIONS, textInputDataReducer } from "Components/Forms/FormReducers/TextInputReducer";
import { commentsMatch, getCommentTempInputData, getErrorList, handleErrorMessages, highlightApi, logS, validateCommentAPI } from "../Util/Utilities";
import { commentInputDataReducer } from "../FormData/CommentsReducer";
import { COMMENT_ACTIONS, commentStateReducer } from "../FormData/CommentStateReducer";
import { http } from "Utils";
import { setGlobalErrorStatus } from "Components/StatusHandling";
import { useDispatch } from "react-redux";
import { ERROR_MESSAGES } from "Utils/constants";
import { config } from "../../../../Utils/config";

function ItemList({setDefaultFocusItem, defaultFocusItem, focusKeywordId, activeSearch, setActiveSearch, itemListRefs, setItemListRefs, highlighted, setHighlighted,handleStatusClose,setStatusData,setStatusVariant,setShowStatusPopup,categoryId, events, activeCommentKey, setActiveCommentKey, commentInput, commentInputDispatch, tempCommentList, tempCommentListDispatch, mobile, activeAccordion, setActiveAccordion, activeEl, setActiveEl, moduleItems,commentsList,commentsListDispatch }) {
    const dispatch = useDispatch();
    
    //const [activeCommentKey, setActiveCommentKey] = useState(null);
    
    //Temporary storage for comment while modifying before it is saved to commentsList
    //var [tempCommentList, tempCommentListDispatch] =  useReducer(commentStateReducer, {});

    const moduleItemsConRef = useRef(null);

    useEffect(()=>{
        //console.log(activeSearch);
        if(activeSearch==false){
            CSS.highlights.clear();
        }
        if(highlighted!=null && Object.keys(highlighted).length>0){
            highlightApi(moduleItemsConRef, highlighted.term, "search-results",null,["split-item-num", "item-num"]);
        }
    },[highlighted, setHighlighted,activeSearch, mobile])

    const handleActiveCommentChange = async (newId, checkEmpty) => {
        //console.log("handleActiveCommentChange",tempCommentList, newId);
        config.isDebugEnabled && console.log("%cInitiate %c- Active Key Change %c- %s -> %s", logS.bold, logS.colors.purple, logS.bold, activeCommentKey, newId, tempCommentList);
        var isSuccess = false;
        if(tempCommentList!=null && newId!=null){
            const entriesArray = Object.entries(tempCommentList);
            const filteredEntries = entriesArray.filter(([key, value]) => {
                return (value.status === "add" || value.status === "edit") && (newId!=null && newId!=key);
            });

            if(filteredEntries.length>0){
                var change = null;
                const results = await Promise.all(
                    filteredEntries.map(async entry => {
                        //console.log(entry);
                        try {
                            var id = entry[0];
                            //var value = entry[1];

                            var s = getCommentTempInputData(tempCommentList,id,"status");
                            var d = getCommentTempInputData(tempCommentList,id,"input");
                            const e = await validateCommentAPI(d.value, categoryId, id, false,id );
                            //console.log(e);
                            if(s=="edit"){
                                checkEmpty=true;
                            }
                            else{
                                checkEmpty=false;
                            }
                            var r = getErrorList(e);
                            var result = {
                                item: getCommentTempInputData(tempCommentList,id),
                                errors: r
                            }
                            return result;
                        } catch (err) {
                            console.error(`Failed to fetch user ${id}`, err);
                            return { id, name: 'Unknown User' }; // fallback value
                        }
                    })
                );
                //console.log(results);

                for(var x = 0 ; x<results.length ; x++){
                    var r = results[x].errors;
                    var item = results[x].item;
                    //console.log(item);
                    var id = item.item.id;
                    var s = getCommentTempInputData(tempCommentList,id,"status");
                    var d = getCommentTempInputData(tempCommentList,id,"input");
                    if(r!=null && r.length>0){
                        var arr = [];
                        var isEmpty = false;

                        if(s!=null){
                            if(s=="add"){
                                for(var x = 0 ; x<r.length ; x++){
                                    if(r[x].code==200){
                                        isEmpty=true;
                                    }
                                    else{
                                        arr.push(r[x].msg);
                                    }
                                }
                                if(isEmpty==true){
                                    if(change==null){
                                        change=true;
                                    }
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.REMOVE_COMMENT,
                                        id: d.name
                                    });
                                }
                                else{
                                    change=false;
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                        errors: arr,
                                        name: d.name
                                    });

                                    config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                    if (d.InputRef.current) {
                                        (d.InputRef.current).focus();
                                    }
                                }
                            }
                            if(s=="edit"){
                                if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) == true){
                                    if(change==null){
                                        change=true;
                                    }
                                    tempCommentListDispatch({
                                        type: "update-comment-status",
                                        name: id,
                                        status: 'view'
                                    })
                                }
                                else{
                                    for(var x = 0 ; x<r.length ; x++){
                                        //console.log(r[x]);
                                        arr.push(r[x].msg);
                                    }
                                    change=false;
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                        errors: arr,
                                        name: d.name
                                    });
                                    
                                    config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                    if (d.EditRef.current) {
                                        (d.EditRef.current).focus();
                                    }
                                }
                            }
                        }
                    }
                    else{
                        if(change==null){
                            change=true;
                        }
                        var i = getCommentTempInputData(tempCommentList,id,"item");
                        
                        if(s!=null){
                            if(s=="add"){
                                commentsListDispatch({
                                    type: "add-comment",
                                    input: d,
                                    item: i,
                                    date: new Date()
                                });
                            }
                            if(s=="edit"){
                                
                                if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) != true){
                                    commentsListDispatch({
                                        type: "update-comment",
                                        input: d,
                                        item: i,
                                        date: new Date()
                                    })
                                }
                            }
                        }

                        tempCommentListDispatch({
                            type: "update-comment-status",
                            name: id,
                            status: 'view'
                        })
                        
                    }
                }

                if(change==true){
                    setActiveCommentKey(newId);
                    isSuccess=true;
                }
            }
            else{
                setActiveCommentKey(newId);
                isSuccess=true;
            }
        }

        if(isSuccess==true){
            config.isDebugEnabled && console.log("%cActive Key Change - %cSuccess%c - %s -> %s", logS.colors.purple, logS.colors.green, logS.bold,activeCommentKey, newId, tempCommentList);
        }
        else{
            config.isDebugEnabled && console.log("%cActive Key Change - %cFailed%c - %s -> %s", logS.colors.purple, logS.colors.red, logS.bold,activeCommentKey, newId, tempCommentList);
        }
        
        return isSuccess;
    }

    return (
        <div className="d-flex ">
            <Col id="ct-module-items-container" className="px-0 p-md-4 ct-module-events bg-color-base-white shadow2" xs={12} lg={12} ref={moduleItemsConRef}>
                <Accordion alwaysOpen 
                    className="bg-color-base-white" 
                    activeKey={activeAccordion}
                    bsPrefix="ct-accordion"
                    key={'topAccordion'}
                >
                    {
                        (Object.keys(events)).includes('x')
                        ?   
                            <Card 
                                className={"bg-color-base-white level-" + events['x']['item'].itemLevel} 
                                key={"Card-" + events['x']['item'].id}
                            >
                                <AccordionHeader
                                setDefaultFocusItem={setDefaultFocusItem}
                                     defaultFocusItem={defaultFocusItem}
                                    handleActiveCommentChange={handleActiveCommentChange}
                                    eventKey={events['x']['item'].id} 
                                    activeAccordion={activeAccordion} 
                                    setActiveAccordion={setActiveAccordion}
                                    activeCommentKey={activeCommentKey}
                                    setActiveCommentKey={setActiveCommentKey}
                                    // activeCommentKeyValue={activeCommentKeyValue}
                                    // setActiveCommentKeyValue={setActiveCommentKeyValue}
                                    activeEl={activeEl} 
                                    setActiveEl={setActiveEl} 
                                    isEnd={true}
                                    isX={true}
                                    item={events['x']['item']}
                                    commentsList={commentsList}
                                    commentsListDispatch={commentsListDispatch}
                                    moduleItems={moduleItems}
                                    mobile={mobile}
                                    
                                    tempCommentList={tempCommentList}
                                    tempCommentListDispatch={tempCommentListDispatch}
                                    categoryId={categoryId}

                                    handleStatusClose={handleStatusClose}
                                    setStatusData={setStatusData}
                                    setStatusVariant={setStatusVariant}
                                    setShowStatusPopup={setShowStatusPopup}
                                    highlighted={highlighted}
                                                                    setHighlighted={setHighlighted}
                                                                    itemListRefs={itemListRefs}
                                                                    setItemListRefs={setItemListRefs}
                                                                    focusKeywordId={focusKeywordId}
                                ></AccordionHeader>
                            </Card>
                        :   null
                    }
                    {
                        Object.keys(events).map((keyName, i)=>{ 
                            if(keyName!='x'){
                                return (
                                    <Item2 
                                    setDefaultFocusItem={setDefaultFocusItem}
                                        defaultFocusItem={defaultFocusItem}
                                        handleActiveCommentChange={handleActiveCommentChange}
                                        activeAccordion={activeAccordion} 
                                        setActiveAccordion={setActiveAccordion} 
                                        activeCommentKey={activeCommentKey}
                                        setActiveCommentKey={setActiveCommentKey}
                                        // activeCommentKeyValue={activeCommentKeyValue}
                                        // setActiveCommentKeyValue={setActiveCommentKeyValue}
                                        current={events[keyName]} 
                                        activeEl={activeEl} 
                                        setActiveEl={setActiveEl} 
                                        index={i+1} 
                                        k={keyName}
                                        moduleItems={moduleItems}
                                        commentsList={commentsList}
                                        commentsListDispatch={commentsListDispatch}
                                        key={"item2"+keyName}
                                        mobile={mobile}
                                        commentInput={commentInput}
                                        commentInputDispatch={commentInputDispatch}
                                        tempCommentList={tempCommentList}
                                        tempCommentListDispatch={tempCommentListDispatch}
                                        categoryId={categoryId}

                                        handleStatusClose={handleStatusClose}
                                        setStatusData={setStatusData}
                                        setStatusVariant={setStatusVariant}
                                        setShowStatusPopup={setShowStatusPopup}
                                        highlighted={highlighted}
                                        setHighlighted={setHighlighted}
                                        itemListRefs={itemListRefs}
                                                                    setItemListRefs={setItemListRefs}
                                                                    focusKeywordId={focusKeywordId}
                                    ></Item2>
                                )
                            }
                        })
                    }

                </Accordion>

            </Col>
            
        </div>
    );
}

export default ItemList;